export default __webpack_public_path__ + "static/media/logo.f217962c.svg";